import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 40,
	viewBox: "0 0 43 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1361_28811)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.7342 1.72266L0 8.60873L10.7342 15.3935L21.4684 8.60873L10.7342 1.72266ZM32.2025 1.72266L21.4684 8.60873L32.2025 15.3935L42.9367 8.60873L32.2025 1.72266ZM0 22.2796L10.7342 29.1657L21.4684 22.2796L10.7342 15.3935L0 22.2796ZM32.2025 15.3935L21.4684 22.2796L32.2025 29.1657L42.9367 22.2796L32.2025 15.3935ZM10.7342 31.3935L21.4684 38.2796L32.2025 31.3935L21.4684 24.6087L10.7342 31.3935Z",
			fill: "#0062FF"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1361_28811",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 42.9369,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgDropbox;
